import { patch } from "@rails/request.js"

window.selectAgentServiceRequest = function(serviceRequestId) {
  patch(`/agent/service_requests/${serviceRequestId}/select`)
  .then(response => {
    Turbo.visit(window.location.href, { action: 'replace' })
  })
}

window.deselectAgentServiceRequest = function() {
  patch('/agent/service_requests/deselect')
  .then(response => {
    Turbo.visit(window.location.href, { action: 'replace' })
  })
}
